package com.devi3east.bashbuddy.di

import com.devi3east.bashbuddy.auth.ui.AuthViewModel
import com.devi3east.bashbuddy.cart.ui.CartViewModel
import com.devi3east.bashbuddy.common.service.AppConfigViewModel
import com.devi3east.bashbuddy.dashboard.ui.DashboardViewModel
import com.devi3east.bashbuddy.features.detail.ui.RecipeDetailViewModel
import com.devi3east.bashbuddy.features.events.detail.ui.EventDetailViewModel
import com.devi3east.bashbuddy.favorites.ui.FavoriteEventsViewModel
import com.devi3east.bashbuddy.features.events.feed.ui.EventFeedViewModel
import com.devi3east.bashbuddy.footer.ui.FooterViewModel
import com.devi3east.bashbuddy.ktor.stripe.ui.StripeViewModel
import com.devi3east.bashbuddy.preferences.AppPreferences
import com.devi3east.bashbuddy.search.ui.SearchViewModel
import org.koin.core.module.dsl.viewModel
import org.koin.dsl.module

fun viewModelModule()  = module {

    viewModel {
        AuthViewModel(
            repository = get(),
            preferences = get(),
            authCapability = get()
        )
    }

    viewModel {
        StripeViewModel(
            urlOpener = get(),
            repository = get(),
            tokenProvider = { get<AppPreferences>().getToken() }
        )
    }

    viewModel {
        EventFeedViewModel(get())
    }

    viewModel {
        EventDetailViewModel(
            repository = get(),
            ticketingCapability = get(),
            tokenProvider = { get<AppPreferences>().getToken() }
        )
    }

    viewModel {
        FavoriteEventsViewModel(
            repository = get(),
            tokenProvider = { get<AppPreferences>().getToken() }
        )
    }

    viewModel {
        DashboardViewModel(
            repository = get(),
            tokenProvider = { get<AppPreferences>().getToken() }
        )
    }

    viewModel {
        CartViewModel(
            repository = get(),
            tokenProvider = { get<AppPreferences>().getToken() },
            urlOpener = get(),
            cartStorage = get()
        )
    }

    viewModel {
        AppConfigViewModel(
            repository = get(),
            versionCheckService = get()
        )
    }

    viewModel {
        RecipeDetailViewModel(get())
    }

    viewModel {
        SearchViewModel(get())
    }

    viewModel {
        FooterViewModel(get())
    }

}